import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'kve-input-filter',
  templateUrl: './input-filter.component.html',
  styleUrls: ['./input-filter.component.scss']
})
export class InputFilterComponent {
  @Input() placeholder: string = 'Filter...';
  @Input() debounceMs: number = 300;
  @Output() filterChange = new EventEmitter<string>();

  filterControl = new FormControl('');

  ngOnInit() {
    this.filterControl.valueChanges
      .pipe(
        debounceTime(this.debounceMs),
        distinctUntilChanged()
      )
      .subscribe(value => {
        console.log(value);
        this.filterChange.emit(value || '');
      });
  }

  clearFilter() {
    this.filterControl.setValue('');
  }
}
